import { uniqBy } from 'lodash';

import {
  FETCH_JOURNAL_TRAFFIC_START,
  FETCH_JOURNAL_TRAFFIC_SUCCESS,
  FETCH_JOURNAL_TRAFFIC_FAIL,
} from './action';

const initialState = {
  journalTraffic: {
    items: [],
    total: 0,
    err: null,
  },
  isLoading: true,
  isInitial: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
  case FETCH_JOURNAL_TRAFFIC_START:
    return {
      ...state,
      journalTraffic: {
        ...state.journalTraffic,
      },
      isLoading: true,
    };
  case FETCH_JOURNAL_TRAFFIC_SUCCESS:
  {
    const incomingItems = Array.isArray(payload.data?.items) ? payload.data.items : [];
    let items = [];
    if (payload.params?.page > 1) {
      items = uniqBy([...state.journalTraffic.items, ...incomingItems], 'sessionId');
    } else {
      items = incomingItems;
    }
    return {
      ...state,
      journalTraffic: {
        ...state.journalTraffic,
        items,
        total: payload.data?.total ?? 0,
      },
      isLoading: false,
      isInitial: true,
    };
  }
  case FETCH_JOURNAL_TRAFFIC_FAIL:
    return {
      ...state,
      journalTraffic: {
        ...state.journalTraffic,
        err: payload,
      },
      isLoading: false,
      isInitial: true,
    };
  default:
    return { ...state };
  }
};
